import DotLoader from "../../../common/core-ui/DotLoader.tsx";
import styles from "./FreeBookActivator.module.scss";
import { useEffect } from "react";
import { getReaderURL, getSystemErrorURL } from "../../bookshelfLinks.ts";
import { useCurrentFullLocale } from "../../../common/utils/locale.ts";
import { useLocation, useParams } from "react-router-dom";
import { useActivateFreeBookFetcher } from "./activate.ts";

export default function FreeBookActivator() {
  const fetcher = useActivateFreeBookFetcher();
  const locale = useCurrentFullLocale();
  const params = useParams();
  const location = useLocation();

  useEffect(() => {
    if (fetcher.state === "idle" && !fetcher.data) {
      void fetcher.submit(
        {},
        {
          action: `/free-books/${params.vbid}/activate`,
          method: "POST",
        }
      );
    }
  }, [fetcher, params]);

  useEffect(() => {
    if (fetcher.data) {
      if (fetcher.data.ok && fetcher.data.vbid) {
        window.location.replace(getReaderURL(fetcher.data.vbid));
      } else {
        window.location.replace(getSystemErrorURL({ locale }));
      }
    }
  }, [fetcher, locale, location.search]);

  return (
    <div className={styles.loadingContainer}>
      <DotLoader />
    </div>
  );
}
